import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, OnDestroy } from '@angular/core';
import { CsCardInterfaceClass } from 'components/cs-card/cs-card';

@Component({
    selector: 'cs-card-list-row',
    templateUrl: 'cs-card-list-row.html',
    providers: [{ provide: CsCardInterfaceClass, useExisting: CsCardListRowComponent }],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { 'class': 'card-list-row' }
})
export class CsCardListRowComponent extends CsCardInterfaceClass implements AfterViewInit, OnDestroy {
  private heightCache: number = 0;
  private resizeObserver: ResizeObserver | undefined;

  constructor(elemRef: ElementRef) {
    super(elemRef);
  }

  ngAfterViewInit(): void {
    // set up ResizeObserver to track height changes
    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(() => {
        this.updateHeight();
      });
      this.resizeObserver.observe(this.elemRef.nativeElement);
    }

    // initial height calculation
    setTimeout(() => {
      this.updateHeight();
      if (this.list) {
        this.list.updatePositions();
      }
    }, 0);
  }

  ngOnDestroy(): void {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  updateLayout(): void {
    // called by card list to update layout
    this.updateHeight();
  }

  private updateHeight(): void {
    if (!this.elemRef || !this.elemRef.nativeElement) {
      return;
    }

    const element = this.elemRef.nativeElement as HTMLElement;
    const newHeight = element.offsetHeight;

    if (newHeight > 0 && newHeight !== this.heightCache) {
      const oldHeight = this.heightCache;
      this.heightCache = newHeight;
      // set CSS variables for animations
      element.style.setProperty('--current-height', `${newHeight}`);
      element.style.setProperty('--current-height-px', `${newHeight}px`);

      // notify list of height change only if height actually changed
      if (this.list && oldHeight !== newHeight) {
        // defer to avoid sync updates
        requestAnimationFrame(() => {
          this.list.updatePositions();
        });
      }
    }
  }

  getCurrentCardHeight(): number {
    // return cached height or calculate fresh
    if (this.heightCache > 0) {
      return this.heightCache;
    }

    if (this.elemRef && this.elemRef.nativeElement) {
      const height = this.elemRef.nativeElement.offsetHeight;
      if (height > 0) {
        this.heightCache = height;
      }
      return height;
    }

    return 0;
  }

  getCardElement(): HTMLElement {
    return this.elemRef.nativeElement;
  }
}
